<template>
  <CCard>
    <CCardBody>
      <h5 class="text-muted" v-if="title != undefined">{{title}}</h5>
      <p class="text-muted" v-if="subtitle != undefined"><em>{{subtitle}}</em></p>
      <CInput v-if="search !== false"
          label="Filtre :" 
          :horizontal="{label: 'col-0', input: 'col-2'}"
          :lazy=400
          v-on:update:value="x => filter=x"
          />
      <b-table hover small caption-top
          :sticky-header="sticky_header"
          :items="items"
          :fields="fields" 
          :filter="filter"
          >
        <!--
        <template v-if="title !== undefined" v-slot:table-caption><b>{{title}}</b></template>
        -->
      </b-table>
    </CCardBody>
  </CCard>
</template>

<script>

export default {
  name: 'BootstrapVueTable',
  props: ['sticky_header', 'items', 'fields', 'search', 'title', 'subtitle'],
  data () {
    return {
      filter: null,
    }
  }
}
</script>